import { multipleBeacons } from 'app-webtech-core/beacon/multipleBeacons';
import { withFields } from 'app-webtech-core/beacon/withFields';
import {
  CM_END,
  CM_BEGIN,
  CM_IMPRESSION,
  CM_POD_START,
  CM_POD_END,
  CM_COMPLETE,
  CM_FIRST_QUARTILE,
  CM_MID_POINT,
  CM_START,
  CM_THIRD_QUARTILE,
  CM_POD_BEGIN,
  CM_POD_COMPLETE,
  CM_ERROR,
} from '../actions/types';

import { cmEndBeacon } from './cmEnd';
import { cmBeginBeacon } from './cmBegin';
import { cmImpressionBeacon } from './cmImpression';
import { cmPodStartBeacon } from './cmPodStart';
import { cmPodEndBeacon } from './cmPodEnd';
import { cmCompleteBeacon } from './cmComplete';
import { cmFirstQuartileBeacon } from './cmFirstQuartile';
import { cmMidPointBeacon } from './cmMidPoint';
import { cmStartBeacon } from './cmStart';
import { cmThirdQuartileBeacon } from './cmThirdQuartile';
import { cmPodBeginBeacon } from './cmPodBegin';
import { cmPodCompleteBeacon } from './cmPodComplete';
import { msnAdStartBeacon } from './msnAdStart';
import { msnAdEndBeacon } from './msnAdEnd';
import { cmErrorBeacon } from './cmError';

export const podTrackerAdsDefinitionsMap = {
  [CM_POD_BEGIN]: multipleBeacons(withFields(cmPodBeginBeacon), msnAdStartBeacon),
  [CM_POD_START]: withFields(cmPodStartBeacon),
  [CM_BEGIN]: withFields(cmBeginBeacon),
  [CM_IMPRESSION]: withFields(cmImpressionBeacon),
  [CM_START]: withFields(cmStartBeacon),
  [CM_FIRST_QUARTILE]: withFields(cmFirstQuartileBeacon),
  [CM_MID_POINT]: withFields(cmMidPointBeacon),
  [CM_THIRD_QUARTILE]: withFields(cmThirdQuartileBeacon),
  [CM_COMPLETE]: withFields(cmCompleteBeacon),
  [CM_END]: withFields(cmEndBeacon),
  [CM_POD_COMPLETE]: withFields(cmPodCompleteBeacon),
  [CM_ERROR]: withFields(cmErrorBeacon),
  [CM_POD_END]: multipleBeacons(withFields(cmPodEndBeacon), msnAdEndBeacon),
};
